import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import "translations/i18n";
import { I18nextProvider } from "react-i18next";
import { i18nInit } from "translations/i18n";
import { BrowserRouter } from "react-router-dom";

ReactDOM.render(
  <I18nextProvider i18n={i18nInit}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </I18nextProvider>,
  document.getElementById("root")
);
